<template>
  <div id="stripe-container">
    <form @submit.prevent="onSubmit">
      <div id="form">
        <input
          v-model="cardHolderName"
          name="name"
          :placeholder="$t('name')"
          @focus="hanlderFocus"
          @blur="hanlderBlur"
          v-validate="'required'"
          :class="[{'error-border': nameError || nameError1}, 'cardholder-name']"
        />
        <p class="error" v-show="nameError || nameError1">
          <span>{{ errors.first('name') || cardNameErrorMsg }}</span>
        </p>

        <div id="card-element" :class="[{'error-border': cardError !== ''}, 'card-element field']"></div>
        <p class="error" v-show="cardError">
          <span>{{ cardError }}</span>
        </p>
      </div>
    </form>
  </div>
</template>

<script>
import Spinner from '../Spinner.vue';
import locales from './lang';
import { mapState } from 'vuex';

export default {
  name: 'Stripe',
  locales,
  components: { Spinner },
  props: {
    orderError: { type: String, default: ' ' },
    isSubscribe: false,
    hanlderNameError: { type: Function, default: () => {} }
  },
  data: function () {
    return {
      cardHolderName: '',
      stripeToken: '',
      loading: false,
      showNameError: true,
      cardNameErrorMsg: this.$t('cardNameErrorMsg')
    };
  },
  computed: {
    nameError() {
      return this.showNameError && this.errors.has('name');
    },
    language() {
      return this.$store.state.currentLang;
    },
    ...mapState({
      stripe: state => state.stripe,
      card: state => state.card,
      cardError: state => state.cardError,
      nameError1: state => state.nameError1
    })
  },
  watch: {
    cardHolderName(val) {
      this.showNameError = false;
      this.hanlderNameError(this.cardHolderName);
    },
    card(val) {
      if (val) {
        this.card.mount('#card-element');
        let striptVm = this;
        let isError = false;
        this.card.on('change', function (event) {
          striptVm.$store.commit('setCardNumberEmpty', event.empty);
          if (event.error) {
            isError = true;
            striptVm.$store.commit('setCardError', event.error.message);
          } else {
            isError = false;
            striptVm.$store.commit('setCardError', '');
          }
        });
        this.card.on('blur', event => {
          if (!isError) {
            var dom = $('#pay-order');
            var top = dom.scrollTop();
            this.unScroll(top);
          }
        });
      }
    }
  },
  mounted() {
    if (window.Stripe) {
      if (this.isSubscribe) {
        this.$store.commit('setStripe', window.Stripe(process.env.STRIPE_SUBSCRIPTION_API_KEY));
      } else {
        this.$store.commit('setStripe', window.Stripe(process.env.STRIPE_API_KEY));
      }
      this.init();
    }
  },
  methods: {
    unScroll(top) {
      var dom = $('#pay-order');
      dom.on('scroll.unable', function (e) {
        dom.scrollTop(top);
        dom.unbind('scroll.unable');
      });
    },
    init() {
      let style = {
        base: {
          fontSize: '14px',
          lineHeight: '24px',
          color: '#555555',
          '::placeholder': {
            color: '#c5c5c5'
          }
        }
      };
      this.$store.commit('setCard', this.stripe.elements({ locale: this.language || 'en' }).create('card', { style: style }));
    },
    hanlderFocus() {
      this.$store.commit('setNameError1', false);
      this.cardNameErrorMsg = '';
    },
    hanlderBlur() {
      this.showNameError = true;
      this.$store.commit('setNameError1', false);
      this.cardNameErrorMsg = '';
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import '../../assets/scss/mixins/button';

* {
  font-size: 0.14rem;
  padding: 0;
  margin: 0;
}

#form {
  .cardholder-name {
    background-color: #ffffff !important;
    border: 0.01rem solid #999;
    border-radius: 0.05rem;
    color: #555555;
    outline: none;
    padding: 0 0.15rem;
    cursor: text;
    width: 100%;
    height: 0.5rem;
    line-height: 0.5rem;
    display: inline-block;
    @media screen and (max-width: 767px) {
      height: 0.45rem;
      line-height: 0.45rem;
    }
  }

  .card-element {
    margin-top: 0.2rem;
    padding: 0.13rem 0.15rem;
    color: #555555;
    border: 0.01rem solid #999;
    border-radius: 0.05rem;
    height: 0.5rem;
    line-height: 0.5rem;
    @media screen and (max-width: 767px) {
      height: 0.45rem;
      line-height: 0.45rem;
    }
  }
  .cardholder-name::-webkit-input-placeholder {
    color: #c5c5c5;
  }
  .cardholder-name::-moz-placeholder {
    color: #c5c5c5;
  }
  .cardholder-name:-ms-input-placeholder {
    color: #c5c5c5;
  }

  .error-border {
    border: 0.01rem solid red;
  }

  .error {
    font-size: 0.12rem;
    padding: 0;
    height: 0.32rem;
    line-height: 0.32rem;
    color: #f95050;
    text-align: right;
    span {
      line-height: 0.32rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Stripe.vue?2c5b40ca